// ============================================================
// Sticky breadcrumb + toolbar positioning
// Hide sticky breadcrumb/toolbar at end of product grid
// ============================================================
(function() {
    const header = document.getElementById('sn_header-new');
    const breadcrumb = document.querySelector('.nav_indicator_wrapper');

    if (!header || !breadcrumb) return;

    let sentinel = document.getElementById('bc-sticky-sentinel');
    if (!sentinel) {
        sentinel = document.createElement('div');
        sentinel.id = 'bc-sticky-sentinel';
        sentinel.style.height = "1px";
        breadcrumb.parentNode.insertBefore(sentinel, breadcrumb);
    }

    let isLocked = false;
    let stickyRaf = 0;
    let cachedBcHeight = 0;
    let cachedToolbarHeight = 0;
    let lastBcTop = null;
    let lastToolbarTop = null;
    let lastHide = null;
    let isMobile = window.innerWidth <= 768;

    function getToolbar() {
        return document.querySelector('.boost-sd__toolbar-inner');
    }

    function getToolbarContainer() {
        return document.querySelector('.boost-sd__toolbar-container');
    }

    function refreshCachedHeights(toolbar) {
        cachedBcHeight = breadcrumb.offsetHeight;
        cachedToolbarHeight = toolbar ? toolbar.offsetHeight : 0;
    }

    function applyStickyFrame() {
        stickyRaf = 0;

        const headerBottom = header.getBoundingClientRect().bottom;
        const sentinelTop = sentinel.getBoundingClientRect().top;
        const toolbar = getToolbar();
        const toolbarContainer = getToolbarContainer();
        const boostContainer = document.querySelector('.boost-sd-container');
        const containerBottom = boostContainer ? boostContainer.getBoundingClientRect().bottom : 0;

        if (isLocked && !cachedBcHeight) {
            refreshCachedHeights(toolbar);
        }

        if (sentinelTop <= headerBottom) {
            if (!isLocked) {
                breadcrumb.style.backgroundColor = "#ffffff";
                breadcrumb.classList.add('is-locked');
                isLocked = true;
                lastHide = null;
                refreshCachedHeights(toolbar);
            }

            if (lastBcTop !== headerBottom) {
                breadcrumb.style.setProperty('top', `${headerBottom}px`, 'important');
                lastBcTop = headerBottom;
            }
            if (toolbar && cachedBcHeight) {
                const toolbarTop = headerBottom + cachedBcHeight;
                if (lastToolbarTop !== toolbarTop) {
                    toolbar.style.setProperty('top', `${toolbarTop}px`, 'important');
                    lastToolbarTop = toolbarTop;
                }
            }

            if (!boostContainer) {
                if (lastHide !== false) {
                    lastHide = false;
                    breadcrumb.style.setProperty('visibility', 'visible', 'important');
                    if (toolbarContainer) toolbarContainer.style.setProperty('visibility', 'visible', 'important');
                }
                return;
            }

            const offset = isMobile ? 40 : 0;
            const hideThreshold = headerBottom + cachedBcHeight + cachedToolbarHeight + offset;
            const shouldHide = containerBottom <= hideThreshold;
            if (lastHide !== shouldHide) {
                lastHide = shouldHide;
                breadcrumb.style.setProperty('visibility', shouldHide ? 'hidden' : 'visible', 'important');
                if (toolbarContainer) toolbarContainer.style.setProperty('visibility', shouldHide ? 'hidden' : 'visible', 'important');
            }
        } else if (isLocked) {
            breadcrumb.classList.remove('is-locked');
            breadcrumb.style.top = 'auto';
            breadcrumb.style.setProperty('visibility', 'visible', 'important');
            isLocked = false;
            lastBcTop = null;
            lastToolbarTop = null;
            lastHide = null;
            cachedBcHeight = 0;
            cachedToolbarHeight = 0;
            if (toolbar) {
                toolbar.style.top = `${headerBottom}px`;
            }
            if (toolbarContainer) {
                toolbarContainer.style.setProperty('visibility', 'visible', 'important');
            }
        }
    }

    function scheduleSticky() {
        if (stickyRaf) return;
        stickyRaf = requestAnimationFrame(applyStickyFrame);
    }

    function invalidateStickyCache() {
        cachedBcHeight = 0;
        cachedToolbarHeight = 0;
        lastBcTop = null;
        lastToolbarTop = null;
        lastHide = null;
    }

    window.addEventListener('scroll', scheduleSticky, { passive: true });
    window.addEventListener('resize', function() {
        isMobile = window.innerWidth <= 768;
        invalidateStickyCache();
        scheduleSticky();
    });
    window.addEventListener('load', function() {
        invalidateStickyCache();
        scheduleSticky();
    });
    scheduleSticky();

    let mutationTimer;
    const observer = new MutationObserver(function() {
        clearTimeout(mutationTimer);
        mutationTimer = setTimeout(function() {
            invalidateStickyCache();
            scheduleSticky();
        }, 150);
    });
    const observeTarget = document.querySelector('.boost-sd-container') || document.body;
    observer.observe(observeTarget, { childList: true, subtree: true });
})();
